import CityPageTemplate from "../city-template/CityPageTemplate";
import { sheridanWyConfig } from "./data";

export default function SheridanWyPage() {
  return <CityPageTemplate config={sheridanWyConfig} />;
}